// The University of Pittsburgh's undergraduate majors (Pittsburgh campus).
// Read on 2026-10-01 from the official 2026-2027 Undergraduate Catalog
// (catalog.upp.pitt.edu, catoid=241). The catalog's Academic Programs page
// lists programs by type (Major, Joint Major, Minor, Certificate, ...); each
// school's catalog page links the programs it offers, and that is the
// grouping used here. Kept: every Major and Joint Major line with a
// bachelor's degree, and the School of Dental Medicine's Dental Hygiene
// Hybrid Studies, BS (listed as Professional). Left out: minors,
// certificates, concentrations, the Accelerated programs (BS/MS and BS-MS
// combinations, the second-degree BSN), the combined Computer Science BS/MS
// and Statistics BS/MA, the Associate of Science in Dental Hygiene, and the
// Frederick Honors College's Bachelor of Philosophy and Honors Degree (an
// honors credential added to a major, not a major). The four Nursing BSN
// curriculum lines (by class year) are one major here. A major offered as
// both a BA and a BS is one line with both degrees. The School of Business
// page names eight majors (Business Analytics among them, which has no
// program page yet); General Management, BSBA is also kept because the
// Academic Programs page lists it. Joint majors offered by two schools
// (Computational Biology, Data Science, ...) appear under both. Swanson's
// page says every engineering program leads to the Bachelor of Science in
// Engineering (BSE); the Arabic major page names no degree.
const majors = {
    "slug": "university-of-pittsburgh",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the University of Pittsburgh's official 2026-2027 Undergraduate Catalog for the Pittsburgh campus, grouped by the school that offers it, with the degree it leads to. Minors, certificates, combined bachelor's and master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Kenneth P. Dietrich School of Arts and Sciences",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, Kenneth P. Dietrich School of Arts and Sciences",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27487"
            },
            "majors": [
                {
                    "name": "Actuarial Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Africana Studies - English",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Arabic",
                    "degree": null
                },
                {
                    "name": "Architectural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Computational Social Science",
                    "degree": "BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Digital Narrative and Interactive Design",
                    "degree": "BA/BS"
                },
                {
                    "name": "Ecology and Evolution",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Economics-Statistics",
                    "degree": "BS"
                },
                {
                    "name": "English Literature",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender, Sexuality, and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History and Philosophy of Science",
                    "degree": "BA"
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA",
                    "note": "A co-major, taken with another major."
                },
                {
                    "name": "International and Area Studies",
                    "degree": "BPHIL"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Korean",
                    "degree": "BA"
                },
                {
                    "name": "Law, Criminal Justice, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics - Economics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Museum Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Quantum Computing",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA, BPHIL"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public and Professional Writing",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Studio Arts",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Urban Planning & Geographic Analysis",
                    "degree": "BS"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Business",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27485"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "General Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Global Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Human Resources Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "School of Computing and Information",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Computing and Information",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27419"
            },
            "majors": [
                {
                    "name": "Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Computational Social Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Digital Narrative and Interactive Design",
                    "degree": "BA/BS"
                },
                {
                    "name": "Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Quantum Computing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Education",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27473"
            },
            "majors": [
                {
                    "name": "Applied Developmental Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Combined Applied Studies in Education",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Teacher Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Swanson School of Engineering",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, Swanson School of Engineering",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27474"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "BSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BSE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Natural Gas, Renewables, and Oil Engineering",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "School of Health and Rehabilitation Sciences",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Health and Rehabilitation Sciences",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27475"
            },
            "majors": [
                {
                    "name": "Communication Science",
                    "degree": "BA"
                },
                {
                    "name": "Emergency Medicine",
                    "degree": "BS"
                },
                {
                    "name": "Health Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BS"
                },
                {
                    "name": "Rehabilitation Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Nursing",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27476"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Pharmacy",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27477"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BSPS"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Public Health",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27420"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BSPH"
                }
            ]
        },
        {
            "name": "School of Public and International Affairs",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Public and International Affairs",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27425"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Social Work",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27478"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BASW, BPHIL"
                }
            ]
        },
        {
            "name": "College of General Studies",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, College of General Studies",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27486"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                },
                {
                    "name": "Health Services",
                    "degree": "BA, BS"
                },
                {
                    "name": "Law, Criminal Justice, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Media and Professional Communications",
                    "degree": "BA"
                },
                {
                    "name": "Natural Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Service",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "David C. Frederick Honors College",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, David C. Frederick Honors College",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27418"
            },
            "majors": [
                {
                    "name": "Politics and Philosophy",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Dental Medicine",
            "source": {
                "label": "Pitt 2026-2027 Undergraduate Catalog, School of Dental Medicine",
                "url": "https://catalog.upp.pitt.edu/content.php?catoid=241&navoid=27488"
            },
            "majors": [
                {
                    "name": "Dental Hygiene Hybrid Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
